interface CardConfigs {
  [key: string]: any;
}

const cardConfigs: CardConfigs = {
  info: {
    primaryButton: {
      icon: "box",
      text: "Review",
      variant: "dark"
    },
    secondaryButton: {
      text: "Defer",
      variant: "light"
    }
  },
  "sell-through": {
    primaryButton: {
      icon: "box",
      text: "Review",
      variant: "dark"
    },
    secondaryButton: {
      text: "Defer",
      variant: "light"
    }
  },
  "predicted-sales": {
    primaryButton: {
      icon: "thumbsup",
      text: "Accept",
      variant: "dark"
    },
    secondaryButton: {
      icon: "pencil",
      text: "Edit",
      variant: "light"
    }
  }
};

export const getHeaderConfig = (type: any): any => {
  return cardConfigs[type] || cardConfigs.info;
};
